import { useEffect, useState, useMemo } from 'react'
import { Box, Select, Flex, Heading, useColorModeValue } from '@chakra-ui/react'
import { useQuery, gql } from '@apollo/client'
import { useParams } from 'react-router-dom'

import { Console } from '../../../components'

const LOGS_QUERY = gql`
  query ($appName: String!) {
    app(name: $appName) {
      id
      processes {
        id
        isMain
        key
        log
      }
    }
  }
`

const Logs = () => {
  const { name } = useParams()
  const borderColor = useColorModeValue('gray.300', 'whiteAlpha.300')
  const [selectedKey, setSelectedKey] = useState<string | null>(null)
  const { data, loading } = useQuery(LOGS_QUERY, {
    variables: { appName: name },
    pollInterval: 3000,
  })

  const processes = useMemo(() => data?.app?.processes ?? [], [data])

  useEffect(() => {
    if (!selectedKey) {
      const mainProcess =
        processes.find((process: any) => process?.isMain) ?? ''
      if (mainProcess) {
        setSelectedKey(mainProcess.key)
      }
    }
  }, [selectedKey, processes, setSelectedKey])

  const logs =
    processes.find((process: any) => process.key === selectedKey)?.log ?? ''

  return (
    <Box p={4} rounded="lg" border="1px" borderColor={borderColor}>
      <Flex mb={4} alignItems="center" justifyContent="space-between">
        <Heading as="h2" size="md">
          Logs of processes
        </Heading>
        <Select
          colorScheme="cyan"
          value={selectedKey ?? ''}
          onChange={(e) => setSelectedKey(e.target.value)}
          isDisabled={!selectedKey || loading}
          maxW="250px"
        >
          {processes.map((process: any) => (
            <option key={process.id} value={process.key}>{`${process.key}${
              process.isMain ? ' (main)' : ''
            }`}</option>
          ))}
        </Select>
      </Flex>
      <Console isLoading={!selectedKey || loading} logs={logs.trim()} h={400} />
    </Box>
  )
}

export default Logs
